import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("teacher_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (path) => (path ? `${BACKEND}/api/media/${path}` : null);

export function errorText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
